// Auto-generated resource for Practice — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const PracticeKeys = {
  Validations: {
    RequestBodyRequired: 'Practice.Validations.RequestBodyRequired',
    NotImproviseFamily: 'Practice.Validations.NotImproviseFamily',
    NotReadAloudFamily: 'Practice.Validations.NotReadAloudFamily',
    NotKnownPractice: 'Practice.Validations.NotKnownPractice',
    NotStorytellingVibe: 'Practice.Validations.NotStorytellingVibe',
    PersonalSeedInvalid: 'Practice.Validations.PersonalSeedInvalid',
    ArchetypeSequenceInvalid: 'Practice.Validations.ArchetypeSequenceInvalid',
    BodyGesturesInvalid: 'Practice.Validations.BodyGesturesInvalid',
    BodyGesturesEmpty: 'Practice.Validations.BodyGesturesEmpty',
    DurationMustBePositive: 'Practice.Validations.DurationMustBePositive',
    LengthSecondsOutOfRange: 'Practice.Validations.LengthSecondsOutOfRange',
    CuesPerMinuteOutOfRange: 'Practice.Validations.CuesPerMinuteOutOfRange',
    OffBookStoryRequired: 'Practice.Validations.OffBookStoryRequired',
    OffBookStoryTooLong: 'Practice.Validations.OffBookStoryTooLong',
    OffBookStructuralFrameworkInvalid: 'Practice.Validations.OffBookStructuralFrameworkInvalid',
    OffBookEnrichmentLensInvalid: 'Practice.Validations.OffBookEnrichmentLensInvalid',
    StoryImprovMinLength: 'Practice.Validations.StoryImprovMinLength',
    StoryImprovStructuralFrameworkInvalid: 'Practice.Validations.StoryImprovStructuralFrameworkInvalid',
    StoryImprovEnrichmentLensInvalid: 'Practice.Validations.StoryImprovEnrichmentLensInvalid',
  },
  Admin: {
    AnonymousQuotaReset: 'Practice.Admin.AnonymousQuotaReset',
    UserQuotaReset: 'Practice.Admin.UserQuotaReset',
  },
  Streaming: {
    GenerationFailed: 'Practice.Streaming.GenerationFailed',
    ContentTooShort: 'Practice.Streaming.ContentTooShort',
  },
  Quota: {
    ChallengeRequired: 'Practice.Quota.ChallengeRequired',
  },
  SpendCeiling: {
    HighDemandUnpaid: 'Practice.SpendCeiling.HighDemandUnpaid',
  },
} as const;

export const PracticeValues = {
  'default': {
    'Admin.AnonymousQuotaReset': 'Reset {0} anonymous practice quota(s) for today',
    'Admin.UserQuotaReset': 'Reset {0} user practice quota(s) for today',
    'Quota.ChallengeRequired': 'Lots of practice has come from your network today. Confirm you\'re human to keep going.',
    'SpendCeiling.HighDemandUnpaid': 'We\'re at unusually high demand right now. Sign up or upgrade to keep practising, or try again shortly.',
    'Streaming.ContentTooShort': 'The AI wrote a piece far shorter than the length you picked. Please try again.',
    'Streaming.GenerationFailed': 'We couldn\'t generate your practice content. Please try again.',
    'Validations.ArchetypeSequenceInvalid': 'Archetype sequence contains entries outside the canonical vocabulary.',
    'Validations.BodyGesturesEmpty': 'Pick at least one body-language technique.',
    'Validations.BodyGesturesInvalid': 'Body-language selection contains entries outside the canonical vocabulary.',
    'Validations.CuesPerMinuteOutOfRange': 'Cue density must be between {0} and {1} cues per minute.',
    'Validations.DurationMustBePositive': 'Duration must be positive.',
    'Validations.LengthSecondsOutOfRange': 'Take length must be between {0} and {1} seconds.',
    'Validations.NotImproviseFamily': 'Practice \'{0}\' is not an improvise family member.',
    'Validations.NotKnownPractice': 'Practice \'{0}\' is not a known practice.',
    'Validations.NotReadAloudFamily': 'Practice \'{0}\' is not a read-aloud family member.',
    'Validations.NotStorytellingVibe': 'Vibe \'{0}\' is not a Storytelling vibe.',
    'Validations.OffBookEnrichmentLensInvalid': 'Enrichment lenses must be VAKS or AMS only.',
    'Validations.OffBookStoryRequired': 'Your story text is required.',
    'Validations.OffBookStoryTooLong': 'Your story must be at most {0} characters.',
    'Validations.OffBookStructuralFrameworkInvalid': 'The structural framework must be 4MAT or the Storytelling Formula.',
    'Validations.PersonalSeedInvalid': 'Personal seed contains disallowed control sequences.',
    'Validations.RequestBodyRequired': 'Request body is required.',
    'Validations.StoryImprovEnrichmentLensInvalid': 'Enrichment lenses must be VAKS or AMS only.',
    'Validations.StoryImprovMinLength': 'Storytelling take length must be at least {0} seconds (3 minutes).',
    'Validations.StoryImprovStructuralFrameworkInvalid': 'The structural framework must be 4MAT or the Storytelling Formula.',
  },
  'vi-VN': {
    'Admin.AnonymousQuotaReset': 'Đã đặt lại {0} hạn mức luyện tập ẩn danh cho hôm nay',
    'Admin.UserQuotaReset': 'Đã đặt lại {0} hạn mức luyện tập của người dùng cho hôm nay',
    'Quota.ChallengeRequired': 'Hôm nay mạng của bạn đã luyện tập rất nhiều. Hãy xác nhận bạn là người thật để tiếp tục.',
    'SpendCeiling.HighDemandUnpaid': 'Hiện lượng truy cập đang cao bất thường. Hãy đăng ký hoặc nâng cấp để tiếp tục luyện tập, hoặc thử lại sau ít phút.',
    'Streaming.ContentTooShort': 'AI đã viết một đoạn ngắn hơn nhiều so với độ dài bạn chọn. Vui lòng thử lại.',
    'Streaming.GenerationFailed': 'Chúng tôi không tạo được nội dung luyện tập cho bạn. Vui lòng thử lại.',
    'Validations.ArchetypeSequenceInvalid': 'Trình tự nguyên mẫu chứa các mục nằm ngoài bộ từ vựng chuẩn.',
    'Validations.BodyGesturesEmpty': 'Hãy chọn ít nhất một kỹ thuật ngôn ngữ cơ thể.',
    'Validations.BodyGesturesInvalid': 'Lựa chọn ngôn ngữ cơ thể chứa các mục nằm ngoài bộ từ vựng chuẩn.',
    'Validations.CuesPerMinuteOutOfRange': 'Mật độ gợi ý phải nằm trong khoảng từ {0} đến {1} gợi ý mỗi phút.',
    'Validations.DurationMustBePositive': 'Thời lượng phải lớn hơn 0.',
    'Validations.LengthSecondsOutOfRange': 'Độ dài bản thu phải nằm trong khoảng từ {0} đến {1} giây.',
    'Validations.NotImproviseFamily': 'Bài luyện \'{0}\' không thuộc nhóm ứng tác.',
    'Validations.NotKnownPractice': '\'{0}\' không phải là một bài luyện hợp lệ.',
    'Validations.NotReadAloudFamily': 'Bài luyện \'{0}\' không thuộc nhóm đọc to.',
    'Validations.NotStorytellingVibe': '\'{0}\' không phải là một không khí hợp lệ cho Kể chuyện.',
    'Validations.OffBookEnrichmentLensInvalid': 'Ống kính bổ trợ chỉ có thể là VAKS hoặc AMS.',
    'Validations.OffBookStoryRequired': 'Cần có nội dung câu chuyện của bạn.',
    'Validations.OffBookStoryTooLong': 'Câu chuyện của bạn chỉ được dài tối đa {0} ký tự.',
    'Validations.OffBookStructuralFrameworkInvalid': 'Khung cấu trúc phải là 4MAT hoặc Công thức Kể chuyện.',
    'Validations.PersonalSeedInvalid': 'Nội dung cá nhân hóa chứa chuỗi điều khiển không được phép.',
    'Validations.RequestBodyRequired': 'Cần có nội dung yêu cầu.',
    'Validations.StoryImprovEnrichmentLensInvalid': 'Ống kính bổ trợ chỉ có thể là VAKS hoặc AMS.',
    'Validations.StoryImprovMinLength': 'Bản thu Kể chuyện phải dài ít nhất {0} giây (3 phút).',
    'Validations.StoryImprovStructuralFrameworkInvalid': 'Khung cấu trúc phải là 4MAT hoặc Công thức Kể chuyện.',
  },
} as const;

